// The type definitions for this file are purposefully updated by hand in types.d.ts

let objToString = (value) => {
    return Object.prototype.toString.call(value);
};

export function isNull (value) {
    return value === null;
}

export function isUndefined(value) {
    return value === undefined;
}

export function isNil (value) {
    return value == null;
}

export function isNotNil(value) {
    return value != null;
}

export function isString (value) {
    return typeof value === 'string'; 
}

export function isSymbol(value) {
    return typeof value === "symbol";
}

export function isObject (value) {
    return value != null && (typeof value === 'object');
}

export function isDate (value){
    return isObject(value) && value instanceof Date;
}

export function isFunction(value) {
    return typeof value === 'function';
}

export function isRegExp (value) {
    return isObject(value) && (objToString(value) === '[object RegExp]' || (value instanceof RegExp));
}

export function isBoolean (value) {
    return value === true || value === false;
}

export function isNumber(value) {
    return typeof value === 'number';
}

export function isInt (value) {
    return isNumber(value) && (value % 1) === 0;
}

export function isUint (value) {
    return isInt(value) && value > -1;
}


export function hasPropertyWithType(value, prop, typeCheckFn) {
    return isObject(value) && (prop in value) && typeCheckFn(value[prop]);
}


export function isPropertyKey(value) {
    return isString(value) || isUint(value) || isSymbol(value);
}

function getTypeofName(value){
    return (value === null)? "null" : (typeof value);
}

export function isPrimitive(value){
    const typeName = getTypeofName(value);
    return typeName !== "object" && typeName !== "function";
}


export function isDefinedPrimitive(value){
    return (value == null)? false : isPrimitive(value);
}

export function isJQueryElement(value){
    return value instanceof /** @type {any}*/(globalThis).jQuery;
}